import { create } from 'zustand';

interface InstallModalStore {
  isOpen: boolean;
  openInstallModal: () => void;
  closeInstallModal: () => void;
  peekAt: number;
  triggerPeek: () => void;
  floatingVisible: boolean;
  setFloatingVisible: (visible: boolean) => void;
}

export const useInstallModalStore = create<InstallModalStore>((set) => ({
  isOpen: false,
  openInstallModal: () => set({ isOpen: true }),
  closeInstallModal: () => set({ isOpen: false }),
  peekAt: 0,
  triggerPeek: () => set({ peekAt: Date.now() }),
  floatingVisible: true,
  setFloatingVisible: (visible: boolean) => set({ floatingVisible: visible }),
}));
